// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_Stn","cls2":"UserTaggingPingBodyStyles-cls2_AVR UserTaggingPingBodyStyles-cls1_Stn"};